export default __webpack_public_path__ + "static/Transcript_Form-f890343f4e0337ff8e03d827ea7eaba1.pdf";